import { render, staticRenderFns } from "./InviteCard.vue?vue&type=template&id=e1c918d0&scoped=true"
import script from "./InviteCard.vue?vue&type=script&lang=js"
export * from "./InviteCard.vue?vue&type=script&lang=js"
import style0 from "./InviteCard.vue?vue&type=style&index=0&id=e1c918d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1c918d0",
  null
  
)

export default component.exports